import * as React from 'react';

/**
 * @description Heart icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Heart } from '@sravni/design-system-icons'
 *
 * <Heart />
 * ```
 */
const Heart = React.forwardRef((props, ref) => (React.createElement("svg", { ref: ref, "data-qa": "Heart", viewBox: "0 0 21 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
    React.createElement("path", { clipRule: "evenodd", d: "M10.736 4.41c.613-.717 1.672-1.521 3.286-1.521 2.821 0 4.714 2.649 4.714 5.115 0 5.157-6.42 9.107-8 9.107s-8-3.95-8-9.107c0-2.466 1.894-5.115 4.715-5.115 1.613 0 2.673.804 3.285 1.52Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))));

export { Heart };
//# sourceMappingURL=Heart.js.map
